<div class="row col-12 col-sm-12 manage-user-registration-container my-account-container">
  <div class="col-3 col-sm-3 left-side my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'UsersNavNode'"
    [childNavState]="'RegistrationRequestNavNode'"></app-my-account-left-sidenav>
  </div>

  <div class="myAccountMyProfile col-12 col-sm-12 col-md-12 col-lg-9 right-side my-account-right-nav">
    <h1 class="manageUserTopHeader m-0">{{'common.text_user_registraion_request_label'|cxTranslate}}
    </h1>
    <div class="my-section-box">
      <div class="myProfileButtonContainer">
        <div class="my-section-box-inner">
          <div class="row">
            <div
              class="col-xs-12 col-sm-12 col-md-12 d-flex align-items-center justify-content-between title">
              <label
              class="company-users-section-headerline">{{'common.text_companyRegistrationRequest_content'|cxTranslate}}</label>
            </div>
          </div>
          @if (!userList?.customerList) {
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 d-flex justify-content-center">
                <label
                class="no-user">{{'common.text_company_manageUser_registration_noRequestFound'|cxTranslate}}</label>
              </div>
            </div>
          }
        </div>

        @if (userList?.customerList) {
          <div class="sort-section">
            <div class="gray-search-result-box">
              {{totalResult}}<div class="d-lg-none">
              <div class="mobile-select">
                <span class="mobile-select-label">Sort by:</span>
                <div class="select-box">
                  <select class="mobile-sorting-dropdown form-control" name="sort">
                    <option
                      value="/my-company/organization-management/manage-users/sort?sort=byDateDesc"
                      selected="selected">
                    Date-Desc</option>
                    <option
                      value="/my-company/organization-management/manage-users/sort?sort=byDate">
                    Date-Asc</option>
                    <option
                      value="/my-company/organization-management/manage-users/sort?sort=byName">
                    Name-Asc</option>
                    <option
                      value="/my-company/organization-management/manage-users/sort?sort=byNameDesc">
                    Name-Desc</option>
                    <option
                      value="/my-company/organization-management/manage-users/sort?sort=byEmail">
                    Email-Asc</option>
                    <option
                      value="/my-company/organization-management/manage-users/sort?sort=byEmailDesc">
                    Email-Desc</option>
                    <option
                      value="/my-company/organization-management/manage-users/sort?sort=byActive">
                    Active-Asc</option>
                    <option
                      value="/my-company/organization-management/manage-users/sort?sort=byActiveDesc">
                    Active-Desc</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="account-overview-table mycompany-manageUser">
            <table class="responsive-table table table-bordered table-blue manageUserTable">
              <thead>
                <tr class="responsive-table-head hidden-xs hidden-sm">
                  <th scope="col">
                    <a class="a-underline"
                      (click)="sort('date')"><span>{{'common.text_account_orderHistory_mobile_page_sort_byDate'|cxTranslate}}</span></a>
                    </th>
                    <th scope="col">
                      <a class="a-underline"
                        (click)="sort('name')"><span>{{'common.text_account_quote_name'|cxTranslate}}</span></a>
                      </th>
                      <th scope="col">
                        <a class="a-underline"
                          (click)="sort('email')"><span>{{'common.storeDetails_table_email'|cxTranslate}}</span></a>
                        </th>
                        <th scope="col">
                          {{'common.text_core_submit_address_addressPhone'|cxTranslate}}
                        </th>
                        <th scope="col">
                          <a class="a-underline"
                            (click)="sort('city')"><span>{{'common.basket_export_user_city'|cxTranslate}}</span></a>
                          </th>
                          <th scope="col">
                            <a class="a-underline"
                              (click)="sort('country')"><span>{{'common.basket_export_user_country'|cxTranslate}}</span></a>
                            </th>
                            <th>
                            </th>
                          </tr>
                        </thead>
                        @if (userList?.customerList) {
                          <tbody>
                            @for (item of userList?.customerList; track item) {
                              <tr class="responsive-table-item">
                                <td class="responsive-table-cell name">
                                  <span
                                  class="mycompany-registration-lable d-lg-none">{{'common.text_company_administrators_page_sort_byDate'|cxTranslate}}</span>
                                  <span class="mycompnay-registration-value">{{item.kbCreationDate}}</span>
                                </td>
                                <td class="responsive-table-cell name">
                                  <span
                                  class="mycompany-registration-lable d-lg-none">{{'common.text_company_members_name_title'|cxTranslate}}</span>
                                  <a (click)="editUser(item.displayUid)"><span
                                  class="mycompnay-registration-value pointer">{{item.name}}</span></a>
                                </td>
                                <td class="responsive-table-cell email">
                                  <span
                                  class="mycompany-registration-lable d-lg-none">{{'common.text_account_quote_email'|cxTranslate}}</span>
                                  <a (click)="editUser(item.displayUid)"><span
                                  class="mycompnay-registration-value pointer">{{item.displayUid}}</span></a>
                                </td>
                                <td class="responsive-table-cell">
                                  <span class="mycompany-registration-lable d-lg-none">
                                  {{'common.text_core_submit_address_addressPhone'|cxTranslate}}</span>
                                  <span class="mycompnay-registration-value">{{item.defaultAddress.phone}}</span>
                                </td>
                                <td class="responsive-table-cell">
                                  <span
                                  class="mycompany-registration-lable d-lg-none">{{'common.basket_export_user_city'|cxTranslate}}</span>
                                  <span class="mycompnay-registration-value">{{item.defaultAddress.town}}</span>
                                </td>
                                <td class="responsive-table-cell">
                                  <span
                                  class="mycompany-registration-lable d-lg-none">{{'common.basket_export_user_country'|cxTranslate}}</span>
                                  <span
                                  class="mycompnay-registration-value">{{item.defaultAddress.country.name}}</span>
                                </td>
                                <td class="table-action">
                                  <img (click)="editUser(item.displayUid)" src="/icons/edit-icon.png"
                                    class="edit-icon pointer">
                                    <img (click)="retriggerEmail(item.displayUid)" src="/icons/mail-kb.svg"
                                      class="mail-icon pointer">
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            }
                          </table>
                        </div>
                        <div class="account-orderhistory-pagination company-users-pagination">
                          <div class="product__list--wrapper">
                            <div class="pagination-bar">
                              <div class="pagination-toolbar">
                                <div class="row sort-refine-bar">
                                  <div class="col-xs-12 col-sm-6 col-md-6 bottom-result">
                                    <div class="pagination-result">
                                    {{totalResult}}</div>
                                  </div>
                                  <div class="col-xs-12 col-sm-6 col-md-6 kb-pagination-right kb-pagination">
                                    <kb-pagination [pagination]="$any(userList)?.pagination" [defaultPage]="0"
                                    (viewPageEvent)="changePageCustom($event, userList)"></kb-pagination>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>